import React from 'react';
import SchemaViewer from '../components/SchemaViewer';
import DocsViewer from '../components/DocsViewer';
import EventsEditor from '../components/EventsEditor';
import ERDViewer from '../components/ERDViewer';

export default function HomePage() {
    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                <div className="bg-white overflow-hidden shadow rounded-lg">
                    <SchemaViewer />
                </div>
                <div className="bg-white overflow-hidden shadow rounded-lg">
                    <DocsViewer />
                </div>
                <div className="bg-white overflow-hidden shadow rounded-lg">
                    <EventsEditor />
                </div>
                <div className="bg-white overflow-hidden shadow rounded-lg">
                    <ERDViewer />
                </div>
            </div>
        </div>
    );
}